/* BLOUP · ficha de producto: galería con puntos, precio en el botón, agregar al carrito sin recargar,
   historias en video, y pedido por WhatsApp para pagar por transferencia o llave Bre-B. Si algo falla, el formulario normal de Shopify sigue funcionando.
   Packs: se agrega la variante «1 unidad» con la cantidad del pack, y en el carrito los packs antiguos se pasan a unidades,
   para que los descuentos automáticos cobren bien cualquier mezcla. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');

  function gallery(root) {
    var track = root.querySelector('[data-blp-track]');
    var dots = root.querySelector('[data-blp-dots]');
    if (!track || !dots) return;
    var btns = dots.querySelectorAll('button');
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        btns.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        track.querySelectorAll('video').forEach(function (v) {
          var slide = v.closest('li');
          if (slide && Math.abs(slide.offsetLeft - track.scrollLeft) > 10 && !v.paused) v.pause();
        });
      });
    }, { passive: true });
  }

  function cartBubble(sections) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !sections || !sections['cart-icon-bubble']) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var src = doc.querySelector('.shopify-section') || doc.body;
    el.innerHTML = src.innerHTML;
  }

  function form(root) {
    var f = root.querySelector('[data-blp-form]');
    if (!f) return;
    var add = f.querySelector('[data-blp-buy]');
    var price = f.querySelector('[data-blp-price]');
    var err = f.querySelector('[data-blp-error]');
    var dlg = document.querySelector('[data-blp-added]');
    var unitInput = f.querySelector('input[type="hidden"][name="id"]');

    function checked() { return f.querySelector('input[name="quantity"]:checked, input[type="radio"][name="id"]:checked'); }
    function line(c) {
      if (unitInput) return { id: Number(unitInput.value), quantity: Number(c.value) || 1 };
      return { id: Number(c.value), quantity: 1 };
    }
    var waPack = f.querySelector('[data-blp-wa-pack]');
    function sync() {
      var c = checked();
      if (c && price) price.textContent = c.dataset.price;
      if (c && waPack) {
        var free = Number(c.dataset.cents) >= 5000000;
        var msg = '¡Hola BLOUP! 👋 Quiero hacer este pedido:\n– Shiny Kicks · ' + c.dataset.name + ': ' + c.dataset.price +
          '\nSubtotal: ' + c.dataset.price + '\nEnvío: ' + (free ? '¡gratis! 🎉' : 'por confirmar') +
          '\n\nVoy a pagar por transferencia (Bancolombia o llave Bre-B) 💜\n\nMis datos de envío 📦\nNombre:\nCiudad:\nDirección:\nTeléfono:';
        waPack.href = 'https://wa.me/573014006269?text=' + encodeURIComponent(msg);
      }
      document.dispatchEvent(new CustomEvent('blp:variant', { detail: c ? { name: c.dataset.name, price: c.dataset.price } : null }));
    }
    f.addEventListener('change', sync);
    sync();

    if (!window.fetch || !window.FormData) return;
    f.addEventListener('submit', function (ev) {
      var submitter = ev.submitter;
      var goCheckout = submitter && submitter.hasAttribute('data-blp-now');
      ev.preventDefault();
      var c = checked();
      if (!c) return;
      err.hidden = true;
      var btn = submitter || add;
      btn.classList.add('is-busy');
      var drawer = document.querySelector('cart-drawer');
      var sectionIds = drawer && typeof drawer.renderContents === 'function' && !goCheckout
        ? (drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'])
        : ['cart-icon-bubble'];
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [line(c)], sections: sectionIds.join(','), sections_url: location.pathname })
      }).then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      }).then(function (res) {
        btn.classList.remove('is-busy');
        if (!res.ok) {
          err.textContent = res.j.description || res.j.message || 'No pudimos agregarlo. Intenta de nuevo o escríbenos por WhatsApp.';
          err.hidden = false;
          return;
        }
        if (goCheckout) { location.href = '/checkout'; return; }
        var data = res.j.items ? res.j.items[0] : res.j;
        if (drawer && typeof drawer.renderContents === 'function') {
          try {
            data.sections = res.j.sections;
            drawer.renderContents(data);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            return;
          } catch (e) {}
        }
        cartBubble(res.j.sections);
        if (dlg && typeof dlg.showModal === 'function') {
          var d = dlg.querySelector('[data-blp-added-d]');
          if (d) d.textContent = 'Shiny Kicks · ' + c.dataset.name + ' · ' + c.dataset.price;
          dlg.showModal();
        }
      }).catch(function () {
        btn.classList.remove('is-busy');
        HTMLFormElement.prototype.submit.call(f);
      });
    });

    if (dlg) {
      dlg.querySelector('[data-blp-close]').addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
  }

  /* Carrito: si hay packs (variantes de 2 o 3 unidades, p. ej. de la tienda anterior), se cambian por la misma cantidad
     de unidades sueltas. El precio queda igual o menor, nunca mayor, y los descuentos automáticos cobran bien la mezcla. */
  function normalizeCart() {
    if (!window.fetch || !/\/cart\/?$/.test(location.pathname)) return;
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var packs = (cart.items || []).filter(function (i) {
        var m = /^(\d+)\s+unidad/i.exec(i.variant_title || '');
        return m && Number(m[1]) > 1;
      });
      if (!packs.length) return;
      var handle = packs[0].handle;
      return fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (p) {
        var single = (p.variants || []).filter(function (v) { return /^1\s+unidad/i.test(v.title) && v.available; })[0];
        if (!single) return;
        var units = 0, updates = {};
        packs.forEach(function (i) {
          if (i.handle !== handle) return;
          units += Number(/^(\d+)/.exec(i.variant_title)[1]) * i.quantity;
          updates[i.key] = 0;
        });
        if (!units) return;
        return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: single.id, quantity: units }] }) }).then(function (r) {
          if (!r.ok) return;
          return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: updates }) }).then(function () { location.reload(); });
        });
      });
    }).catch(function () {});
  }

  /* Historias en video (pantalla completa, toca a los lados para avanzar o volver) */
  function stories() {
    document.querySelectorAll('[data-bls]').forEach(function (sec) {
      var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-bls-src]'));
      var dlg = sec.querySelector('[data-bls-player]');
      if (!cards.length || !dlg || typeof dlg.showModal !== 'function') return;
      var video = dlg.querySelector('video');
      var bars = dlg.querySelector('[data-bls-bars]');
      var cap = dlg.querySelector('[data-bls-cap]');
      var sound = dlg.querySelector('[data-bls-sound]');
      var idx = 0;
      bars.innerHTML = cards.map(function () { return '<span><i></i></span>'; }).join('');
      var spans = bars.querySelectorAll('span');
      function show(i) {
        if (i < 0) i = 0;
        if (i >= cards.length) { dlg.close(); return; }
        idx = i;
        spans.forEach(function (s, j) { s.classList.toggle('is-done', j < idx); s.firstChild.style.width = j < idx ? '100%' : '0'; });
        video.src = cards[idx].dataset.blsSrc;
        video.poster = cards[idx].dataset.blsPoster || '';
        cap.textContent = cards[idx].dataset.blsCap || '';
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
      video.addEventListener('timeupdate', function () {
        if (video.duration) spans[idx].firstChild.style.width = (video.currentTime / video.duration * 100) + '%';
      });
      video.addEventListener('ended', function () { show(idx + 1); });
      cards.forEach(function (c, i) { c.addEventListener('click', function () { dlg.showModal(); show(i); }); });
      dlg.querySelector('[data-bls-prev]').addEventListener('click', function () { show(idx - 1); });
      dlg.querySelector('[data-bls-next]').addEventListener('click', function () { show(idx + 1); });
      dlg.querySelector('[data-bls-close]').addEventListener('click', function () { dlg.close(); });
      sound.addEventListener('click', function () {
        video.muted = !video.muted;
        sound.textContent = video.muted ? 'Activar sonido' : 'Silenciar';
      });
      dlg.addEventListener('close', function () { video.pause(); video.removeAttribute('src'); video.load(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(idx - 1);
        if (e.key === 'ArrowRight') show(idx + 1);
      });
    });
  }

  /* Pedido por WhatsApp para pagar por transferencia (Bancolombia o llave Bre-B): arma el mensaje con lo que hay en el carrito */
  function waOrder() {
    var PHONE = '573014006269', FREE_MIN = 5000000;
    function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-CO'); }
    function units(i) {
      var m = /^(\d+)\s+unidad/i.exec(i.variant_title || '');
      return (m ? Number(m[1]) : 1) * i.quantity;
    }
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('[data-bl-wa-order]');
      if (!a || !window.fetch) return;
      ev.preventDefault();
      var fallback = a.href;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.items || !cart.items.length) { location.href = fallback; return; }
        var lines = cart.items.map(function (i) {
          var n = units(i);
          return '– ' + i.product_title + ' · ' + n + (n === 1 ? ' unidad' : ' unidades') + ': ' + money(i.final_line_price);
        });
        var msg = '¡Hola BLOUP! 👋 Quiero hacer este pedido:\n' + lines.join('\n') +
          '\nSubtotal: ' + money(cart.total_price) + '\nEnvío: ' + (cart.total_price >= FREE_MIN ? '¡gratis! 🎉' : 'por confirmar') +
          '\n\nVoy a pagar por transferencia (Bancolombia o llave Bre-B) 💜\n\nMis datos de envío 📦\nNombre:\nCiudad:\nDirección:\nTeléfono:';
        location.href = 'https://wa.me/' + PHONE + '?text=' + encodeURIComponent(msg);
      }).catch(function () { location.href = fallback; });
    });
  }

  function init() {
    waOrder();
    normalizeCart();
    document.querySelectorAll('[data-blp]').forEach(function (root) {
      gallery(root);
      form(root.closest('.shopify-section') || document);
    });
    stories();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
